module.exports = __webpack_public_path__ + "static/media/luana.e06226cc.jpeg";